(function () {
  angular
    .module('specsguardApp')
    .filter('sgSanitize', sgSanitize);

  sgSanitize.$inject = ['$log'];

  /**
   * Can later also be used for displaying user comments, and for element value comparing
   * */
  function sgSanitize ($log) {
    /**
     * @filter sanitize
     * @param untrustedHtml {String} - untrusted html string, aka user input
     * @returns {String} - sanitized html string, can be used with
     *
     * Can later also be used for displaying user comments,
     * */
    return function sanitize (untrustedHtml) {
      // @ts-ignore
      if (!tinymce) {
        $log.error('tinymce not available');
        return '';
      }

      // @ts-ignore
      const serializer = new tinymce.html.Serializer();
      // @ts-ignore
      const domParser = new tinymce.html.DomParser();
      const trustedHtml = serializer.serialize(domParser.parse(untrustedHtml));
      return trustedHtml;
    };
  }
})();
